import React from "react";
import { useNavigate } from "react-router-dom";

const CancelPage = () => {
  const navigate = useNavigate();

  return (
    <div className="relative min-h-screen bg-gradient-to-br from-gray-900 via-black to-gray-800 py-8 px-4 text-white flex items-center justify-center">
      <div className="max-w-2xl mx-auto text-center">
        <div className="bg-gray-900/80 backdrop-blur-sm border border-red-500 rounded-2xl shadow-lg hover:shadow-red-500/50 p-12">
          <div className="flex flex-col items-center space-y-6">
            <svg
              className="w-24 h-24 text-red-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              />
            </svg>
            <h1 className="text-5xl font-extrabold text-red-400 mb-4">
              ⚠️ Payment Canceled
            </h1>
            <p className="text-xl text-gray-300 mb-8 max-w-md mx-auto">
              Your transaction was canceled. You can try again anytime.
            </p>
            <button
              onClick={() => navigate("/pricing")}
              className="px-8 py-4 bg-red-600 hover:bg-red-700 text-white font-semibold text-lg rounded-xl shadow-lg transition-all transform hover:scale-105"
            >
              Back to Pricing
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CancelPage;

